// extracted by mini-css-extract-plugin
export default {"switch_place":"switchPlace_switch_place__Jn8OM","switch_part":"switchPlace_switch_part__qnh+C","switch":"switchPlace_switch__jOHQe","show_switch":"switchPlace_show_switch__IT7q6"};